export default "__VITE_ASSET__mTp90T6e__"